import PackagesHistory from './PackagesHistory';

export default PackagesHistory;
